const React = require("react");
const formatTime = require("mn-utils/formatTime");

const timeTableCellCtor = (Tooltip) => ({date}) => (
  <Tooltip title={formatTime.getRFC3339(date)}>
    <div>{formatTime(date, '{dd} {mmm}, {yyyy}', true)}</div>
    <div className="c717275 fw4 mt3">
      {formatTime(date, '{hh}:{MM}:{ss} {TT}', true)}
    </div>
  </Tooltip>
);

const AdminTimeCell = timeTableCellCtor(require("../Tooltip/A"));
const MerchantTimeCell = timeTableCellCtor(require("../Tooltip/B"));

module.exports = {AdminTimeCell, MerchantTimeCell};
